import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { AiChat } from "@/components/ai/AiChat";
import { memo } from "react";

const Index = memo(() => {
  console.log("Index page rendered");

  return (
    <div className="space-y-12">
      <section>
        <Hero />
      </section>
      
      <section>
        <Features />
      </section>

      <section>
        <AiChat />
      </section>
    </div>
  );
});

Index.displayName = 'Index';

export default Index;